/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Mk_Agent_3_TitleInputs */

const en_mk_agent_3_title = /** @type {(inputs: Mk_Agent_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Knows your codebase`)
};

const id_mk_agent_3_title = /** @type {(inputs: Mk_Agent_3_TitleInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Paham codebase-mu`)
};

/**
* | output |
* | --- |
* | "Knows your codebase" |
*
* @param {Mk_Agent_3_TitleInputs} inputs
* @param {{ locale?: "en" | "id" }} options
* @returns {LocalizedString}
*/
export const mk_agent_3_title = /** @type {((inputs?: Mk_Agent_3_TitleInputs, options?: { locale?: "en" | "id" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Mk_Agent_3_TitleInputs, { locale?: "en" | "id" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "id") return id_mk_agent_3_title(inputs)
	return en_mk_agent_3_title(inputs)
});